export class Gus {
  constructor(gus) {
    this.commune = gus.gmina;
    this.postalCode = gus.kod_pocztowy;
    this.city = gus.miejscowosc;
    this.name = gus.nazwa;
    this.nip = gus.nip;
    this.apartmentNumber = gus.nr_lokalu;
    this.propertyNumber = gus.nr_nieruchomosci;
    this.county = gus.powiat;
    this.regon = gus.regon;
    this.street = gus.ulica;
    this.province = gus.wojewodztwo;
  }
}
